import firebase from 'firebase/compat/app';
import STORE_CONSTANTS, {
  PERFORMANCE_BOARDS_DOC,
  PERFORMANCE_BOARDS_VERSION,
} from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

export { PERFORMANCE_BOARDS_DOC, PERFORMANCE_BOARDS_VERSION };

const performanceBoardsConverter = {
  toFirestore(
    wizardState: PerformanceBoardTypes.Board,
  ): firebase.firestore.DocumentData {
    return withoutNulls({ ...wizardState });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<PerformanceBoardTypes.Board>,
    options: firebase.firestore.SnapshotOptions,
  ): PerformanceBoardTypes.Board {
    const board = snapshot.data(options);
    board.slideout = board.slideout.map((section) => {
      // @ts-ignore
      if (section.sectionType === 'Scoring Reward') {
        return {
          ...section,
          sectionType: 'Bonus Reward',
        };
      }

      // ENG-1263: the section was first released as "Recognition Payments".
      // @ts-ignore
      if (section.sectionType === 'Recognition Payments') {
        return {
          ...section,
          sectionType: 'Additional Payments',
          title:
            section.title === 'Recognition Payments'
              ? 'Additional Payments'
              : section.title,
        };
      }

      // @ts-ignore
      if (section.sectionType === 'Scoring Total Reward') {
        return {
          ...section,
          sectionType: 'Bonus Total Reward',
        };
      }

      return section;
    });

    if (board.isEntityFilterEnabled === undefined) {
      board.isEntityFilterEnabled = false;
    }
    if (board.labelIds === undefined) {
      board.labelIds = [];
    }
    if (board.isAsset === undefined) {
      board.isAsset = false;
    }
    if (board.isV3Published === undefined) {
      board.isV3Published = false;
    }
    if (board.isWeeklyFactTableOverrideEnabled === undefined) {
      board.isWeeklyFactTableOverrideEnabled = false;
    }
    if (board.isSlideoutOverrideEnabled === undefined) {
      board.isSlideoutOverrideEnabled = false;
    }
    if (board.isSlideoutOverrideButtonEnabled === undefined) {
      board.isSlideoutOverrideButtonEnabled = true;
    }
    if (board.isDisqualificationReasonsEnabled === undefined) {
      board.isDisqualificationReasonsEnabled = false;
    }
    if (board.v3Access === undefined) {
      board.v3Access = {
        isPublic: false,
        userIds: [],
        groupIds: [],
      };
    }

    return board;
  },
};

const getPerformanceBoardsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.CONTENT_DISTRIBUTIONS_COLLECTION)
    .doc(PERFORMANCE_BOARDS_DOC)
    .collection(PERFORMANCE_BOARDS_VERSION)
    .withConverter(performanceBoardsConverter);
};

export default getPerformanceBoardsRef;
